import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import CompanySolutions from "../components/CompanySolutions";
import BuildingContractor from "../components/BuildingContractor";
import BuildingSites from "../components/BuildingSites";
import ProductsGrid from "../components/ProductsGrid";
import Partners from "../components/Partners";
import ContactCTA from "../components/ContactCTA";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <CompanySolutions />
        <BuildingContractor />
        <BuildingSites />
        <ProductsGrid />
        <Partners />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
